




































































































import { Component, Vue, Watch } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import EventBus from '@/plugins/EventBus'
import { maskDate } from '@/utils/common'
import RecebimentoStore from '@/components/Recebimento/Store/RecebimentoStore'
import ModalAddTabelaPrestador from './ModalAddTabelaPrestador.vue'

@Component({
  components: {
    ModalAddTabelaPrestador,
  },
})
export default class ModalTabelaPrestador extends Vue {
  readyState = false
  loadGestores = false
  loadModalAddGestor = false
  loadEditHospital = ''
  prestadorSearch = ''
  showModalDelete = false
  itemToDelete: string | null = null

  get getRecebimentoStore() { return getModule(RecebimentoStore, this.$store) }

  get getGestores() { return this.getRecebimentoStore.tabelaPrestadores }

  get loadingShowModalAddTabelaPrestadores() { return this.loadModalAddGestor }
  set loadingShowModalAddTabelaPrestadores(value: boolean) { this.loadModalAddGestor = value }

  get loadingDeletePrestador() { return this.loadEditHospital }
  set loadingDeletePrestador(value: string) { this.loadEditHospital = value }

  get loadingGestores() { return this.loadGestores }
  set loadingGestores(value: boolean) { this.loadGestores = value }

  get getGestoresTableHeader() {
    return [
      { text: 'Prestador', class: 'table-headers', align: 'left', value: 'prestadorNome' },
      { text: 'Tabela preço', class: 'table-headers', align: 'left', value: 'tabelaPreco' },
      { text: 'Criado por', class: 'table-headers', align: 'left', value: 'createdBy' },
      { text: 'Criado em', class: 'table-headers', align: 'left', value: 'createdOn' },
      { text: 'Ações', class: 'table-headers', value: '', align: 'center', sortable: false },
    ]
  }

  get showModalPrestadores() {
    return this.getRecebimentoStore.modalTabelaPrestador
  }

  set showModalPrestadores(value: boolean) {
    this.getRecebimentoStore.setModalTabelaPrestador(value)
  }

  maskDate(date: string) {
    return maskDate(date)
  }

  async showModalAddTabelaPrestadores() {
    this.loadingShowModalAddTabelaPrestadores = true
    await this.getRecebimentoStore.getPrestadores({limite: 20})
    this.getRecebimentoStore.setModalAddTabelaPrestador(true)
    this.loadingShowModalAddTabelaPrestadores = false
  }

  abrirModalExclusao(id: string) {
    this.itemToDelete = id
    this.showModalDelete = true
  }

  async confirmarDeletePrestador() {
    if (!this.itemToDelete) return

    this.loadingDeletePrestador = this.itemToDelete
    const request = await this.getRecebimentoStore.deleteTabelaPrestador(this.itemToDelete)

    if (request.success) {
      EventBus.$emit('setSnackbar', {
        show: true,
        text: 'Prestador removido com sucesso!',
        icon: 'check',
        color: '#43A047',
      })
      this.getRecebimentoStore.getTabelaPrestadores(this.getRecebimentoStore.tabelaPrecoId)
    } else {
      EventBus.$emit('setSnackbar', {
        show: true,
        text: `${request.message} ${String.fromCodePoint(0x1F615)}`,
        icon: 'warning',
        color: '#C62828',
      })
    }

    this.loadingDeletePrestador = ''
    this.itemToDelete = null
    this.showModalDelete = false
  }

  @Watch('showModalPrestadores')
  onChangeShowModalPrestadores(value: boolean) {
    if (!value) {
      this.prestadorSearch = ''
    }
  }
}
